import _get from 'lodash/get'
import { useCallback } from 'react'
import { useNavigate } from 'react-location'
import { useTranslation } from 'react-i18next'

import { useUserLogin } from '../stores/user-store'
import { ICredentials, ILoginResponse } from '../types/'
import { useAuth } from '../components/containers/AuthContainer'
import { useSnackbar } from '../components/containers/SnackbarContainer'

import LoginForm from '../components/LoginForm'
import LeadLiaisonBox from '../components/layouts/LeadLiaisonBox'
import CenteredLayout from '../components/layouts/CenteredLayout'

function LoginView(): JSX.Element {
  const { login } = useAuth()
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { mutate } = useUserLogin()
  const { openSnackbar } = useSnackbar()

  const onLoginSubmit = useCallback(
    (data: ICredentials): Promise<void | string> => {
      return new Promise((resolve, reject) => {
        mutate(data, {
          onSuccess(res: ILoginResponse = {} as ILoginResponse) {
            const { token, refreshToken, user, refreshTokenExpireAt } = res

            if (token && refreshToken && user) {
              login(token, refreshTokenExpireAt, refreshToken, user)
              resolve()
            } else {
              openSnackbar({ severity: 'error', body: t('loginFailed') })
              reject(t('loginFailed'))
            }
          },
          onError(error) {
            openSnackbar({
              severity: 'error',
              title: t('loginFailed'),
              body: _get(error, 'response.data.message', undefined),
            })
            reject(_get(error, 'response.data.message', undefined))
          },
        })
      })
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [mutate, navigate, t]
  )

  return (
    <CenteredLayout>
      <LeadLiaisonBox>
        <LoginForm onSubmit={onLoginSubmit} />
      </LeadLiaisonBox>
    </CenteredLayout>
  )
}

export default LoginView
